<div class="flex flex-col gap-6">
  <div class="ec-category-header">
    {{ 'dashboard.overview.priceelements.title' | translate }}
  </div>

  <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
    <app-status-card [config]="pricingElementOverduePending"></app-status-card>
    <app-status-card [config]="pricingElementRejected"></app-status-card>
    <app-status-card [config]="pricingElementFailed"></app-status-card>
  </div>

  <div class="ec-category-header">
    {{ 'dashboard.overview.pricestatus.title' | translate }}
  </div>

  <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
    <app-status-card [config]="priceStatus"></app-status-card>
  </div>
</div>
